module.exports = __webpack_public_path__ + "static/img/product02-4.f88bf6a2.png";